import { useReducer, useState } from 'react';

import { useContracts } from '../../../../hooks/queries/useContracts';
import { useCreateProperty } from '../../../../hooks/queries/useCreateProperty';
import { useValidateListing } from '../../../../hooks/queries/useValidateListing';
import { listingErrors as listingErrorsReducer, listing as listingReducer } from '../../AddPropertyModal/reducers';

import { EMPTY_ERROR, EMPTY_LISTING } from '../../AddPropertyModal/constants';

import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { UnitAlertValue } from '../../../../constants/AddPropertyConstants';

export const usePropertyFlow = (user?: RentalManagerAuthCheckUserInfoWebApiDto) => {
  const [listing, setListing] = useReducer(listingReducer, EMPTY_LISTING);
  const [listingErrors, setListingErrors] = useReducer(listingErrorsReducer, EMPTY_ERROR);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [unitAlert, setUnitAlert] = useState<UnitAlertValue | null>(null);
  const [propertyAlreadyPostedWarningMessage, setPropertyAlreadyPostedWarningMessage] = useState<
    string | Array<JSX.Element | string>
  >('');
  const [isRefocusingAddressInput, setIsRefocusingAddressInput] = useState(false);
  const [isImpreciseLocation, setIsImpreciseLocation] = useState(false);

  const contractsResponse = useContracts(setListing, setListingErrors, setIsSubmitDisabled, user);

  const { verifyCanSubmitForm, handleCheckLocationRestriction } = useValidateListing(
    listing,
    setListing,
    listingErrors,
    setListingErrors,
    setUnitAlert,
    setPropertyAlreadyPostedWarningMessage,
    setIsImpreciseLocation,
    user,
    contractsResponse,
  );

  const { createProperty } = useCreateProperty();

  return {
    listing,
    setListing,
    listingErrors,
    setListingErrors,
    isSubmitDisabled,
    setIsSubmitDisabled,
    unitAlert,
    setUnitAlert,
    propertyAlreadyPostedWarningMessage,
    setPropertyAlreadyPostedWarningMessage,
    isRefocusingAddressInput,
    setIsRefocusingAddressInput,
    isImpreciseLocation,
    contractsResponse,
    verifyCanSubmitForm,
    handleCheckLocationRestriction,
    createProperty,
  };
};
